export const CostOverrideType = Object.freeze({
  HOURLY_RATE: 'HOURLY_RATE',
  PERCENT_MARKUP: 'PERCENT_MARKUP'
});
